import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterArquivoServicoState } from "../../reducers/Servicos/obter-arquivo-servico-jornal.reducer";

export const selectObterArquivoServicoState = createFeatureSelector<ObterArquivoServicoState>('obterArquivoServico');

export const selectDadosObterArquivoServico = createSelector(
  selectObterArquivoServicoState,
  (state: ObterArquivoServicoState) => state.response
);

export const selectObterArquivoServico = createSelector(
  selectObterArquivoServicoState,
  (state: ObterArquivoServicoState) => state
);

export const selectErrosObterArquivoServico = createSelector(
  selectObterArquivoServicoState,
  (state: ObterArquivoServicoState) => state.error
);
